export default __webpack_public_path__ + "aa047442f7f38827a89583b552dac9df.webp";